import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentsSection, PageTitle } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { LoadingBox } from "component/basic/popup";
import { bottomChk, comFormat } from "js/function";
import { FixedPage, FixedSection } from "component/basic";
import { NotItems } from "component/basic/notItems";
import { PointFixedTap, Tap } from "component/basic/tap";
import { FixedContents } from "component/product/page";
import { MypageBasicListItem, MypageContentsBox, MypageControll, MypageCountBox, PageContentsSection } from "component/mypage/items";

const Point = (props) => {
    const navigate = useNavigate();

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);
    const [category,setCategory] =  useState(null);

    const [page,setPage] =  useState(1);
    const [itemList,setItemList] =  useState([]);
            
    let lastPage = false;
    let settingChk = 0;

    const pageDataApi = useGet({
        url:`/point/history?page=${page}${category ? `&type=${category}` : ""}`,
        loginType:"login"
    });
    const total_point = pageDataApi?.data?.total_point;
    const pageData = pageDataApi?.data?.point_histories;

    useEffect(() => {
        setLoadingBoxOpen(false);
    }, []);

    useEffect(() => {
        setItemList([]);
        setPage(1);
    }, [category]);

    function addPage(){
        setLoadingBoxOpen(true);
        setPage(page + 1);
        settingChk = 1;
        setTimeout(() => {
            settingChk = 0;
        }, 300);
    };
    
    useEffect(() => {
        if(pageData?.data && pageData?.data.length > 0){
            if(page == 1){
                setItemList([...pageData?.data]);
            }else{    
                setItemList(prev => [...prev, ...pageData?.data]);
            }
        }else{
            setItemList([]);
        }

        lastPage = pageData?.current_page < pageData?.last_page;

        setLoadingBoxOpen(false);

        window.removeEventListener("scroll", handleScroll);
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [pageDataApi]);
    
    function handleScroll(){
        if(bottomChk() && lastPage && settingChk == 0){
            addPage();
        }
    };
    
    useEffect(() => {
        setItemList([]);
        const timer = setInterval(() => {
            window.addEventListener("scroll", handleScroll);
        }, 100);
        return () => {
            clearInterval(timer);
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            <ContentsSection
                header={true}
                footer={true}
                addClass={"gBg mTapContents"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"포인트 내역"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={4}
                    closeFunc={()=>{}}
                />
                <FixedPage addClass="reverse mnReverse">
                    <FixedSection
                        pageBox="pageSizing"
                        boxAddClass="fixedsection_min pcItemT"
                        addClass="nonFixed fixedsection_min"
                        contentsBox="fixedPage"
                        nonFixed={true}
                        headerChk={true}
                        footerChk={true}
                        minSize={961}
                    >
                        <MypageControll
                            addClass="pcItemT"
                            data={null}
                        />
                    </FixedSection>
                    <FixedContents addClass="mypageFixedContents">
                        <PageTitle
                            addClass="fixedContents_title pcItemT"
                            pageBack={null}
                            contents="포인트 내역"
                        >
                            <Tap
                                addClass="underLine"
                                data={[
                                    {
                                        id:1,
                                        name:"적립"
                                    },
                                    {
                                        id:2,
                                        name:"차감"
                                    }
                                ]}
                                nameKey={"name"}
                                valKey={"id"}
                                nameCaption={null}
                                val={category}
                                allText="전체"
                                func={(name,val)=>{setCategory(val)}}
                            />
                        </PageTitle>
                        <PointFixedTap
                            boxAddClass={"mItemT row"}
                            headerTap={true}
                            headerChk={true}
                            addClass=""

                            data={[
                                {
                                    id:1,
                                    name:"적립"
                                },
                                {
                                    id:2,
                                    name:"차감"
                                }
                            ]}
                            nameKey={"name"}
                            valKey={"id"}
                            nameCaption={null}
                            val={category}
                            allText="전체"
                            func={(name,val)=>{setCategory(val)}}
                        />
                        <MypageCountBox
                            type="point"
                            title="보유 포인트"
                            val={comFormat(total_point||"0")}
                            unit="포인트"
                            func={()=>{}}
                        />
                        <PageContentsSection addClass="">
                            {itemList && itemList?.length > 0 ? 
                                <MypageContentsBox
                                    nPadding={true}
                                    title={null}
                                >
                                    {itemList && itemList?.map((item, i) => (
                                        <MypageBasicListItem
                                            key={i}
                                            type={"point"}
                                            pointType={item.type}
                                            contents={item.reason}
                                            created_at={item.created_at}
                                            point={item.point}
                                            remain_point={item.total_point}
                                        />
                                    ))}
                                </MypageContentsBox>
                            :
                                <NotItems addClass="fullPage" text={`포인트 내역이 없습니다.`}/>
                            }
                        </PageContentsSection>
                    </FixedContents>
                </FixedPage>
            </ContentsSection>
            <Footer/>
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default Point;